import { render } from "./BillingAndSubscription.vue?vue&type=template&id=56313f61&scoped=true"
import script from "./BillingAndSubscription.vue?vue&type=script&lang=js"
export * from "./BillingAndSubscription.vue?vue&type=script&lang=js"

import "./BillingAndSubscription.vue?vue&type=style&index=0&id=56313f61&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56313f61"]])

export default __exports__